(function () {
  'use strict';
  var root = document.querySelector('[data-woofy-sub]');
  if (!root) return;

  var VARIANT = parseInt(root.getAttribute('data-variant'), 10);
  var GIFTS = (root.getAttribute('data-gifts') || '').split(',').map(function(x){return parseInt(x,10);}).filter(Boolean);
  var PLAN = {
    '15': parseInt(root.getAttribute('data-plan-15'),10),
    '20': parseInt(root.getAttribute('data-plan-20'),10),
    '30': parseInt(root.getAttribute('data-plan-30'),10),
    '60': parseInt(root.getAttribute('data-plan-60'),10)
  };
  var SIZE_MAP = {
    Toy:    { qty:1, plan:PLAN['60'], days:60, label:'60-day supply', title:'60-Day Supply' },
    Small:  { qty:1, plan:PLAN['30'], days:30, label:'30-day supply', title:'30-Day Supply' },
    Medium: { qty:1, plan:PLAN['20'], days:20, label:'20-day supply', title:'20-Day Supply' },
    Large:  { qty:1, plan:PLAN['15'], days:15, label:'15-day supply', title:'15-Day Supply' }
  };

  function getSize(){var el=root.querySelector('.new-custom-bundle-product-main-inp:checked');return el?el.value:'Toy';}
  function isSubscribed(){var t=root.querySelector('.new-custom-bundle-subscribe-inp');return !!(t&&t.checked);}
  function cfg(){return SIZE_MAP[getSize()]||SIZE_MAP.Toy;}

  function syncFrequencyText(){
    var c=cfg();
    var p=root.querySelector('.new-custom-bundle-frequency');
    if(p)p.textContent=isSubscribed()?'Delivered every '+c.days+' days — '+c.label:'One-time purchase';
    var box=root.querySelector('[data-tt-box-supply]'); if(box)box.textContent='1 jar · '+c.label;
    var bt=root.querySelector('[data-tt-box-title]'); if(bt)bt.textContent=c.title;
  }
  function syncGiftLocks(){
    var subbed=isSubscribed();
    root.querySelectorAll('[data-tt-gift]').forEach(function(g){g.classList.toggle('active',subbed);g.classList.toggle('locked',!subbed);});
    var head=root.querySelector('[data-tt-gift-head]');
    if(head)head.textContent=subbed?'🎉 3 FREE Gifts Unlocked':'🔒 Subscribe to unlock 3 FREE gifts';
  }
  function syncPrice(){
    var subbed=isSubscribed();
    root.querySelectorAll('.sdp-tier-price').forEach(function(el){
      var sub=el.getAttribute('data-sub-default'); var one=el.getAttribute('data-onetime-default');
      var next=(subbed&&sub)?sub:one; if(next)el.textContent=next;
    });
    var lbl=root.querySelector('.new-custom-bundle-subscribe'); if(lbl)lbl.classList.toggle('is-active',subbed);
  }
  function syncSaveBadgeAndStrike(){
    var subbed=isSubscribed();
    var save=root.querySelector('[data-tt-box-save]'); if(save)save.style.display=subbed?'':'none';
    root.querySelectorAll('.sdp-tier-compare').forEach(function(el){el.style.display=subbed?'':'none';});
  }
  function syncAll(){syncPrice();syncFrequencyText();syncGiftLocks();syncSaveBadgeAndStrike();}

  root.addEventListener('change',function(e){
    if(!e.target.classList)return;
    if(e.target.classList.contains('new-custom-bundle-subscribe-inp')||e.target.classList.contains('new-custom-bundle-product-main-inp'))syncAll();
  });

  root.addEventListener('click',function(e){
    var btn=e.target.closest('[data-tt-atc]'); if(!btn)return;
    e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
    var c=cfg();var subbed=isSubscribed();var size=getSize();
    var line={id:VARIANT,quantity:c.qty,properties:{'Dog Size':size}};
    if(subbed&&c.plan){line.selling_plan=c.plan;}
    else if(subbed&&!c.plan){console.error('[Woofy] no plan size='+size);btn.textContent='Please try again';setTimeout(function(){btn.textContent=btn.getAttribute('data-label')||'Add To Cart 👉';},2000);return;}
    var items=[line];
    if(subbed)GIFTS.forEach(function(gid){items.push({id:gid,quantity:1,properties:{'_tt_gift':'1'}});});
    var originalText=btn.textContent;btn.disabled=true;btn.classList.add('active');
    var rootUrl=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    fetch(rootUrl+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
      .then(function(){
        if(typeof window.showDrawer==='function'&&typeof window.fetchCart==='function'){window.showDrawer();return window.fetchCart().then(function(cart){if(typeof window.cacheCart==='function')window.cacheCart(cart);if(typeof window.renderFromCache==='function')window.renderFromCache();});}
        window.location.href=rootUrl+'cart';
      })
      .catch(function(err){console.error('[Woofy] ATC error:',err);btn.textContent='Please try again';setTimeout(function(){btn.textContent=originalText;},2000);})
      .finally(function(){btn.disabled=false;btn.classList.remove('active');});
  },true);

  syncAll();
})();
